import { SimpleModal } from "../../../components/Modal";
import ModalTitleContainer from "../../../components/Modal/components/ModalTitleContainer";
import { StyledOkButton, StyledDescription, StyledList } from "./TutorialPopup.styles";

interface TutorialPopupProps {
    isOpen: boolean
    title: string
    description?: string
    listItems: string[]
    onContinue: () => void
    onClose: () => void
}
const TutorialPopup = ({isOpen, title, description,listItems, onContinue, onClose}: TutorialPopupProps) => {
    return (

        <div>
            <SimpleModal
                isOpen={isOpen}
                onClose={onClose}
            >
                <ModalTitleContainer
                    title={title}
                    onClose={onClose}
                />
                {description && <StyledDescription>
                    {description}
                </StyledDescription>}
                <StyledList>
                {listItems && listItems.map((item) => (
                        <StyledDescription>
                            {item}
                        </StyledDescription>
                    ))}
                </StyledList>

                <StyledOkButton
                    variant="contained"
                    color="primary"
                    size="large"
                    id="continue-button"
                    className="bigButtonInNewStyle"
                    onClick={onContinue}
                >
                    Ok
                </StyledOkButton>
            </SimpleModal>
        </div>
    )
}

export default TutorialPopup;